import React from "react";
import { Conversation } from "./types";
import { CallIcon, VideoCallIcon, SlidersIcon, FlameIcon, MuteIcon, WatchTogetherIcon } from "./icons";
import { Avatar, vibeRingKind } from "../Avatar";
import { t } from "../../utils/i18n";

export function ChatHeader({
  selected, typingUser, lang, onBack, onAvatarClick, onVoiceCall, onVideoCall, onWatchTogether, onOpenSettings,
}: {
  selected: Conversation;
  typingUser: string | null;
  lang: string;
  onBack: () => void;
  onAvatarClick: () => void;
  onVoiceCall: () => void;
  onVideoCall: () => void;
  onWatchTogether: () => void;
  onOpenSettings: () => void;
}) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 20px", borderBottom: "1px solid #F0F0F0", backgroundColor: "white" }}>
      <button onClick={onBack} style={{ border: "none", background: "none", cursor: "pointer", color: "#666", fontSize: 20, fontWeight: 700, padding: 0 }}>←</button>
      <div onClick={onAvatarClick} style={{ cursor: "pointer" }}>
        <Avatar
          id={selected.other_user_id || selected.community_id || selected.ritual_id || selected.id}
          name={selected.name}
          uri={selected.avatar_url || selected.cover_url}
          size={36}
          online={selected.online}
          showOnline={selected.type === "direct"}
          ringKind={selected.type === "direct" ? vibeRingKind(selected.other_has_real, selected.other_has_active) : null}
        />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 15, fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "flex", alignItems: "center", gap: 5 }}>{selected.name}{selected.disappearing && <FlameIcon />}{selected.muted && <MuteIcon size={13} color="#bbb" />}</div>
        <div style={{ fontSize: 11, color: selected.type === "direct" && selected.online ? "#0a0a0a" : "#999", display: "flex", alignItems: "center", gap: 4 }}>
          {typingUser ? `${typingUser} ${t(lang,"msg_typing_suffix")||"écrit..."}` :
           selected.type === "direct" ? (selected.online ? (t(lang,"msg_online")||"En ligne") : (t(lang,"msg_offline")||"Hors ligne")) :
           selected.type === "community" ? `${selected.members?.toLocaleString()} ${t(lang,"msg_members")||"membres"}` :
           <>{selected.members} {t(lang,"msg_participants")||"participants"} · <FlameIcon size={11} />{selected.streak}</>}
        </div>
      </div>
      {selected.type === "direct" && selected.other_user_id && (
        <>
          <button onClick={onVoiceCall} style={{ border: "none", background: "none", cursor: "pointer", padding: 4, flexShrink: 0, display: "flex", color: "#666" }} title={t(lang,"msg_call_voice")||"Appel vocal"}>
            <CallIcon />
          </button>
          <button onClick={onVideoCall} style={{ border: "none", background: "none", cursor: "pointer", padding: 4, flexShrink: 0, display: "flex", color: "#666" }} title={t(lang,"msg_call_video")||"Appel vidéo"}>
            <VideoCallIcon />
          </button>
        </>
      )}
      {/* Contrairement aux appels (1:1 uniquement, WebRTC), une salle "Regarder ensemble" repose
          sur une room Socket.IO qui accueille n'importe quel nombre de participants — visible sur
          toute discussion (directe, communauté, rituel), pas seulement les conversations directes. */}
      <button onClick={onWatchTogether} style={{ border: "none", background: "none", cursor: "pointer", padding: 4, flexShrink: 0, display: "flex", color: "#666" }} title={t(lang,"watch_together_cta")||"Regarder ensemble"}>
        <WatchTogetherIcon />
      </button>
      <button onClick={onOpenSettings} style={{ border: "none", background: "none", cursor: "pointer", padding: 4, flexShrink: 0, display: "flex" }} title={t(lang,"msg_customize_title")||"Personnaliser la discussion"}><SlidersIcon /></button>
    </div>
  );
}
